import { POSITION_TYPE } from 'transfix-maps/types'
import { BADGE_COLOR } from 'transfix-ui/components/Badge'
import { ITrackingType } from './types'

export const HOW_THIS_WORKS_LINK =
  'https://support.transfix.io/en/articles/5300474-carrier-app-a-walk-around-the-homepage'

export const TRACKING_LABELS: Record<ITrackingType, string> = {
  onTime: 'On Time',
  runningLate: 'Running Late',
  notTracking: 'Not Tracking',
}

export const TRACKING_BADGE_COLORS: Record<ITrackingType, BADGE_COLOR> = {
  onTime: BADGE_COLOR.blue,
  runningLate: BADGE_COLOR.orange,
  notTracking: BADGE_COLOR.red,
}

export const TRACKING_POSITION_TYPES: Record<ITrackingType, POSITION_TYPE> = {
  onTime: POSITION_TYPE.LAST_PING,
  runningLate: POSITION_TYPE.LAST_PING_OUTDATED,
  notTracking: POSITION_TYPE.LAST_PING_LATE,
}
